/* healmeal – NABU-Spende im Cart-Drawer.
   Fügt das Spendenprodukt (1€-Basis) mit Menge = Betrag hinzu und lädt den
   Drawer neu – identisches Muster wie der Kakao-Upsell (.hm-upsell__add). */
(function(){
  if (window.__hmNabuInit) { return; }
  window.__hmNabuInit = true;

  function refreshDrawer(){
    return fetch(location.pathname + '?section_id=cart-drawer')
      .then(function(r){ return r.text(); })
      .then(function(html){
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('.drawer__inner');
        var cur = document.querySelector('cart-drawer .drawer__inner');
        if (fresh && cur){
          cur.innerHTML = fresh.innerHTML;
          if (window.hmApply) { window.hmApply(); }
          if (window.hmSyncFromCart) { window.hmSyncFromCart(); }
          if (window.hmUpdateResv) { window.hmUpdateResv(); }
        }
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') { d.open(); }
      });
  }

  function addDonation(vid, amount, btn){
    amount = parseInt(amount, 10);
    if (!vid || !amount || amount < 1) { return; }
    if (amount > 5000) { amount = 5000; }
    if (btn) { btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: amount }] })
    })
      .then(function(){ return refreshDrawer(); })
      .catch(function(){})
      .then(function(){ if (btn) { btn.disabled = false; } });
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) { return; }
    var pb = t.closest('.hm-nabu__btn');
    if (pb){
      var box = pb.closest('.hm-nabu');
      addDonation(box && box.getAttribute('data-vid'), pb.getAttribute('data-amount'), pb);
      return;
    }
    var ab = t.closest('.hm-nabu__add');
    if (ab){
      var box2 = ab.closest('.hm-nabu');
      var inp = box2 ? box2.querySelector('.hm-nabu__input') : null;
      var val = inp ? inp.value : '';
      addDonation(box2 && box2.getAttribute('data-vid'), val, ab);
      return;
    }
  });
})();
